import React from "react";
import LoadingStates from "../../constants/states/LoadingStates";
import PrivateMyAdvertisementsStore from "../../stores/PrivateMyAdvertisementsStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import OpenAdvertisementsTableView from "../views/OpenAdvertisementsTableView";
import ClosedAdvertisementsTableView from "../views/ClosedAdvertisementsTableView";
import LoadingView from "../views/LoadingView";


class MyAdvertisementsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "privateMyAdvertisementsStore": PrivateMyAdvertisementsStore.getState(),
        };
    }

    componentDidMount() {
        this.privateMyAdvertisementsStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.PRIVATE_MY_ADVERTISEMENTS_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GET_MY_ADVERTISEMENTS, {});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.privateMyAdvertisementsStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "privateMyAdvertisementsStore": PrivateMyAdvertisementsStore.getState(),
        });
    };

    render() {
        if (this.state.privateMyAdvertisementsStore.myAdvertisementsLoadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Advertisements"/>
            );
        }
        const hash = this._getHashOrDefault();

        return (
            <div className="container mt-13vh p-0 w-100">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="nav nav-tabs card-header-tabs" id="bologna-list" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#open-advertisements") ? "btn nav-link active": "nav-link"}
                                                    id="nav-open-advertisements-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#open-advertisements")}
                                                    role="tab"
                                                    aria-controls="nav-open-advertisements"
                                                    aria-selected="true"
                                                >
                                                    Open Advertisements
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={(hash === "#closed-advertisements") ? "btn nav-link active": "nav-link"}
                                                    id="nav-closed-advertisements-tab"
                                                    onClick={(e) => this._changeHashTo(e, "#closed-advertisements")}
                                                    role="tab"
                                                    aria-controls="closed-advertisements"
                                                    aria-selected="false"
                                                >
                                                    Closed Advertisements
                                                </button>
                                            </li>
                                            <li className="nav-item ml-auto mr-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-cuvered-pink float-right"
                                                    onClick={this.handleNewAdvertisementButtonClick}
                                                >
                                                    <i className="fas fa-plus mr-1" />
                                                    Create New
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <h4 className="card-title">My Advertisements</h4>
                                <div className="tab-content mt-3">
                                    <div className={(hash === "#open-advertisements") ? "tab-pane active": "tab-pane fade"} id="open-advertisements" role="tabpanel" aria-labelledby="nav-open-advertisements-tab">
                                        {<OpenAdvertisementsTableView advertisements={this.state.privateMyAdvertisementsStore.openAdvertisements}/>}
                                    </div>
                                    <div className={(hash === "#closed-advertisements") ? "tab-pane active": "tab-pane fade"} id="closed-advertisements" role="tabpanel" aria-labelledby="nav-closed-advertisements-tab">
                                        {<ClosedAdvertisementsTableView advertisements={this.state.privateMyAdvertisementsStore.closedAdvertisements}/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _changeHashTo(event, newHash) {
        event.stopPropagation();
        window.location.hash = newHash;
    }

    _getHashOrDefault() {
        const hash = window.location.hash
        if(hash === "#closed-advertisements") {
            return hash;
        }
        return "#open-advertisements";
    }

    handleNewAdvertisementButtonClick = () => {
        EventPublisher.publish(UIInteractionEvents.MY_ADVERTISEMENTS_NEW_ADVERTISEMENT_BUTTON_CLICKED, {});
    }
}

export default MyAdvertisementsContainer;